import {
  Box,
  Card,
  CardContent,
  IconButton,
  Stack,
  Tooltip,
  Typography
} from '@mui/material';
import { getFormattedUserNameWithId } from './UserLogin';
import {
  STRATEGY_APPROVER_TOOLTIP,
  STRATEGY_OWNER_TOOLTIP
} from './AppConstants';

export default function StrategyOverviewViewOnly(props) {
  const {
    strategyInformation,
    userInfoMap,
    isEdit,
    editOverview,
    selectedOverviewViewList
  } = props;

  const renderUserName = (transientObj, strategyUserId) => {
    if (transientObj) return transientObj.label;
    if (strategyInformation && userInfoMap)
      return getFormattedUserNameWithId(
        userInfoMap.get(strategyUserId),
        strategyUserId
      );
    return strategyUserId;
  };

  const FieldLabel = ({ label, tooltip, ariaLabel }) => (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <Typography variant='h3'>{label}</Typography>
      <Tooltip title={tooltip}>
        <IconButton aria-label={ariaLabel} size="small">
          <fuel-icon name="info_outlined" />
        </IconButton>
      </Tooltip>
    </Stack>
  );

  return (
    <Box sx={(theme) => ({ mt: theme.fuel6Tokens.JddcSpacingMedium })}>
      <Card>
        <CardContent>
          <Stack direction="row" alignItems="flex-start" spacing={1}>
            {isEdit && (
              <IconButton
                aria-label="edit"
                size="small"
                onClick={(e) => editOverview(e)}
                sx={(theme) => ({
                  borderRadius: theme.fuel6Tokens.JddcRadiusSmall,
                  flexShrink: 0
                })}
              >
                <fuel-icon name="edit" />
              </IconButton>
            )}
            <Box sx={{ flex: 1, display: 'flex', flexDirection: 'row' }}>
              <Box sx={{ flex: 1 }}>
                <FieldLabel
                  label="Strategy Owner"
                  tooltip={STRATEGY_OWNER_TOOLTIP}
                  ariaLabel="Strategy owner information"
                />
                <Typography>
                  {renderUserName(
                    selectedOverviewViewList?.ownerId,
                    strategyInformation?.ownerId
                  )}
                </Typography>
              </Box>
              <Box sx={{ flex: 1 }}>
                <FieldLabel
                  label="Strategy Approver"
                  tooltip={STRATEGY_APPROVER_TOOLTIP}
                  ariaLabel="Strategy approver information"
                />
                <Typography>
                  {renderUserName(
                    selectedOverviewViewList?.approverId,
                    strategyInformation?.approverId
                  )}
                </Typography>
              </Box>
            </Box>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
